import { UserService, ImagesService } from './../../../apiclient';
import { Component, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbDialogService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { RippleService } from '../../../@core/utils/ripple.service';
import { NbAuthJWTToken, NbAuthService, NbAuthSimpleToken } from '@nebular/auth';

import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { UserSessionService } from '../../../UserSession/user-session.service';
import { DomSanitizer } from '@angular/platform-browser';

const helper = new JwtHelperService();

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  @ViewChild('companyaction')
  private companyactionTpl: TemplateRef<any>;

  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  user: any;
  companies: any;
  selectedCompany: any;
  loading = false;
  companylogo: any = window.location.protocol+ "//"+window.location.host + "/assets/images/logosmartruralheader.png";
  headerInited: boolean = false;

  settings = {};  //Esther EV2022-02

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
    {
      value: 'material-light',
      name: 'Material Light',
    },
    {
      value: 'material-dark',
      name: 'Material Dark',
    },
  ];

  currentTheme = 'default';

  userMenu = [ { title: 'Cerrar sesión',action:'closeSession' } ];
  newActionsMenu = [];
  newActionsMenuByRole = {
    'superadmin':[
        {title:'Compañía',link:'',action:'newCompany',icon:'home'},
        {title:'Usuario',link:'',action:'newUser',icon:'people'},
        {title:'CardLink',link:'',action:'newFramelink',icon:'globe'},
        {title:'CustomForm',link:'',action:'newCustomForm',icon:'file-text-outline'},
        {title:'Entidad',link:'',action:'newCustomEntity',icon:'settings-2-outline'}
    ],
    'manager':[
      //{title:'Usuario',link:''},   Esther 19/01/2022
    ],
    'reporter':[

    ]

  }
  subscription: any;
  public constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    private authService: NbAuthService,
    private apiUserService: UserService,
    private userSessionService: UserSessionService,
    private router: Router,
    private dialogService: NbDialogService,
    private imagesService: ImagesService,
    private sanitizer: DomSanitizer,
  ) {
    this.materialTheme$ = this.themeService.onThemeChange()
      .pipe(map(theme => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }));



      /*
      this.authService.onTokenChange().subscribe((token: NbAuthJWTToken) => {


          apiUserService.user("Bearer "+token.toString()).subscribe(usuario => {

            this.user = usuario;

          });

      });

      */



  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

   this.user = this.userSessionService.user;

   this.userSessionService.onSessionCreated().subscribe((user) => {
    this.user = user;
    console.log(user);
    this.user.acl_roles.forEach((role => {
      console.log("Añadiendo el role "+role);
      console.log(this.newActionsMenuByRole[role]);
      this.newActionsMenu = this.newActionsMenu.concat(this.newActionsMenuByRole[role]);
      console.log(this.newActionsMenu);
    }));



    //Cargamos el logo de la compañía
    this.imagesService.imageImagepathGet(this.user.company.dashboardLogoImage,
      this.userSessionService.accessToken).subscribe((data) => {
          console.log(data);
          if(null != data && typeof data != 'undefined'){
            this.companylogo = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(data));
          }

      });

  });
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith('material'));
      });



     this.subscription = this.menuService.onItemClick().subscribe((event) => {

       const evItem = event.item as any;

       if( evItem.action == 'closeSession'){
          this.loading = true;
           this.userSessionService.closeSession().subscribe((exito) => {
             this.loading = false;
            this.router.navigate(['auth/login']);
           })



       }else if (evItem.action == 'newUser'){
         console.log("Queremos crear nuevo usuario");
         this.createUser(this.companyactionTpl);
       }else if (evItem.action == 'newFramelink'){
         console.log("Queremos crear nuevo usuario");
         this.createFramelink(this.companyactionTpl);
       }else if (evItem.action == 'newCompany'){
        console.log("Queremos crear nuevo compañía");
        this.router.navigate(['pages/company/0']);
      }else if (evItem.action == 'newCustomForm'){
        console.log("Queremos crear nuevo compañía");
        this.createCustomForm(this.companyactionTpl);
      }else if (evItem.action == 'newCustomEntity'){
        console.log("Queremos crear nueva entidad");
        this.createCustomEntity(this.companyactionTpl);
      }
     })
     this.settings = {
      text: "Compañía",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      labelKey:"name",
      singleSelection: true,
      enableSearchFilter: true,
    };  //Esther EV2022-02
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  createUser(dialog: TemplateRef<any>): void {
    this.userSessionService.getCompanies().subscribe((companies) => {
      this.companies = companies;
    })
    this.dialogService.open(dialog,{context:{destino: 'pages/usuario', target: 'usuario'}});
  }

  createFramelink(dialog: TemplateRef<any>): void {
    this.userSessionService.getCompanies().subscribe((companies) => {
      this.companies = companies;
    })
    this.dialogService.open(dialog,{context:{destino: 'pages/framelink', target: 'CardLink'}});
  }
  createCustomForm(dialog: TemplateRef<any>): void {
    this.userSessionService.getCompanies().subscribe((companies) => {
      this.companies = companies;
    })
    this.dialogService.open(dialog,{context:{destino: 'pages/customform', target: 'CustomForm'}});
  }

  createCustomEntity(dialog: TemplateRef<any>): void {
    this.userSessionService.getCompanies().subscribe((companies) => {
      this.companies = companies;
    })
    this.dialogService.open(dialog,{context:{destino: 'pages/customentity', target: 'Entidad'}});
  }


  ejecutarNewAction(destino: string): void{
    this.router.navigate([destino,this.selectedCompany[0].id,'0']);

  }
}
